/**
 * Initialize manual carousels for Money Goals Playbook Query Loop patterns.
 *
 * Editors build the playbook list with the Related Posts Query Loop so the
 * cards remain CMS-managed. On the front end, that saved Query Loop markup is
 * adapted to Splide's expected structure without changing the editor workflow.
 */
export function initMoneyGoalsPlaybooks() {
	const carousels = document.querySelectorAll('.gmr-playbook-carousel');

	if (!carousels.length || typeof Splide === 'undefined') {
		return;
	}

	carousels.forEach((carousel) => {
		if (carousel.dataset.gmrPlaybooksCarouselInitialized === 'true') {
			return;
		}

		const list = carousel.querySelector('.wp-block-post-template');

		if (!list) {
			return;
		}

		carousel.classList.add('splide');
		list.classList.add('splide__list');

		Array.from(list.children).forEach((slide) => {
			slide.classList.add('splide__slide');
		});

		if (!list.parentElement.classList.contains('splide__track')) {
			const track = document.createElement('div');

			track.className = 'splide__track';
			list.parentNode.insertBefore(track, list);
			track.appendChild(list);
		}

		carousel.dataset.gmrPlaybooksCarouselInitialized = 'true';

		new Splide(carousel, {
			type: 'slide',
			perPage: 2,
			perMove: 1,
			gap: '1.5rem',
			arrows: true,
			pagination: true,
			autoplay: false,
			breakpoints: {
				768: {
					perPage: 1,
				},
			},
		}).mount();
	});
}
